import { observer } from 'mobx-react-lite';

import { IcBackIcon } from '@gem/icons';
import { AddKeyPressHandler } from '@gem/keyboard-handler';
import { useTranslation } from '@gem/modules/i18n';
import { IconButton } from '@gem/ui-kit';

import usePresenter from './presenter';
import styles from './styles.m.css';

const ScheduleInfo = ({ group }) => {
  const presenter = usePresenter({ group });
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <AddKeyPressHandler onEsc={presenter.onBack} />
      <IconButton
        className={styles.back}
        Icon={IcBackIcon}
        onClick={presenter.onBack}
        size="big"
        iconSize="medium"
        theme="8"
      />
      {t('scheduled_messages')}
    </div>
  );
};

export default observer(ScheduleInfo);
